import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../app/hooks';
import styles from '../sass/components/CarViewer.module.scss';
import { ROUTE_BOOK_SERVICES } from '../util/constants';
import Button from './Button';

export default function CarViewer() {
  const { t } = useTranslation();
  const car = useAppSelector((state) => state.car);
  const navigate = useNavigate();
  return (
    <div className={styles.carViewerBox}>
      <div className={styles.header}>
        <h4>{t('vehicle.yourVehicle')}</h4>
        <Button
          variant="tertiary"
          onClick={() => navigate(ROUTE_BOOK_SERVICES)}
        >
          {t('account.user.edit')}
        </Button>
      </div>
      <p>{`${car.make} ${car.model} ${car.year}`}</p>
    </div>
  );
}
